export default __webpack_public_path__ + "static/media/plt4.5b86909b.png";